export type ENV = 'local' | 'dev' | 'stage' | 'prod';

type EnvConfig = Readonly<{
  env: ENV;
}>;

/**
 * @description vite の env を取得する
 */
export const EnvConfig: EnvConfig = {
  env: import.meta.env.VITE_ENV,
} as const;
